module.exports = __webpack_public_path__ + "img/HQ-ZU3-V1-all.84586442.png";